import GenericBoostModal from "./generic-boost-modal";
import loadingIndicator from "../new-boost/js/loading_indicator";

// order numbers are 4-6 digits long or a 24(?) digit string of hex characters
const validateLcOrderInput = (input) => {
    if (input.length >= 4 && input.length <= 6) {
        return /^\d+$/.test(input);
    }
    if (24 === input.length) {
        return /^[0-9A-Fa-f]+$/.test(input);
    }

    return false;
};

// // sort of a unit test for validateLcOrderInput on currently known valid order numbers
// const testData = {
//     '1': false,
//     '12': false,
//     '123': false,
//     '1234567': false,
//     '123.56': false,
//     '5e0904ecb1f81z00127bc784': false,
//     '5e0904ecb1f81.00127bc784': false,
//     '101589': true,
//     '94540': true,
//     '5e0904ecb1f81c00127bc784': true,
//     '5e27a062e47a8d00123b3f2a': true,
//     '5e2f11870c11fa0012afbbb3': true,
//     '5e517493c81696001225c482': true,
//     '5e73d5cebb16b400124fb889': true,
//     '5eb306b758e4a0001312d042': true,
//     '5eb429a1e73afc0014687243': true,
// };
// // unit test
// function testValidateLcOrderInput() {
//     for (var key in testData) {
//         if (validateLcOrderInput(key) !== testData[key]) {
//             alert(`validateLcOrderInput(${key}) failed to validate correctly`)
//         }
//     }
// }
// testValidateLcOrderInput();


jQuery(document).ready(function ($) {

    // modal to show result of submittal
    let ListingConciergeExtensionModal = new GenericBoostModal(
        '.listing-concierge-extension', // container holding the modal opener - high enough?
        '.nothing_to_click', // modal opening link
        '.lcc-form-results-modal', // modal
        '.lcc-form-results-modal__close--js', // closeModalHandler
        'lcc-form-results-modal--active', // modalActiveClass
        'lcc-form-results-modal__bg', // modalBackgroundClass
    );

    // open on page load
    ListingConciergeExtensionModal.openIfExists();

    // validate input before we submit an order extension
    $('#lc_order_extension_form').on('submit', (e) => {
        let orderNumber = $(`#lc_order_id`).val();
        if (!validateLcOrderInput(orderNumber)) {
            if (!confirm(`${orderNumber} doesn't look like a valid order number. Are you sure you want to submit?`)) {
                e.preventDefault();
            }
        }
    });

    // Check status form js - submit form handler
    $('#lc_order_status_form').on('submit', (e) => {
        e.preventDefault();
        let parameter = 'lc_query';
        let orderNumber = $(`#${parameter}`).val();

        let path = `/dashboard/boost/getlcestatus/cbhomes?${parameter}=${orderNumber}`;

        const resultsClass = '.listing-concierge-extension__search-results--js';

        loadingIndicator.show();

        jQuery.getJSON(path).success(function (response) {
            let html = `<p>${response.message}</p>`;

            let orderStrings = response.results.map((order) => {

                const isExtend = order.is_extend === "1";
                let isExtendText = isExtend ? 'Extension requested' : 'Extension not requested';

                let isIncompleteExtension = false;
                if (isExtend) {
                    switch(order.status) {
                        case 'INCOMPLETE':
                            isIncompleteExtension = true;
                            isExtendText += ' and extension is not completed';
                            break;
                        case 'CREATED_CAMPAIGN':
                            isExtendText += ` and a ${order.days} day campaign was created`;
                            break;
                        case 'INCREASED_EXPOSURE':
                            isExtendText += ` and campaign was extended ${order.days} days`;
                            break;
                    }
                }

                let cancelElement = '';
                if (isIncompleteExtension) {
                    cancelElement =
                        `<span class="listing-concierge-extension__button listing-concierge-extension__button-dont-extend" data-order-id="${order.lc_order_id}">Cancel</span>`;
                }

                return `<li>Order ${order.lc_order_id}: <span>${isExtendText} ${cancelElement}</span></li>`;
            });

            let allOrders = '';
            orderStrings.forEach((string) => {
                allOrders += string;
            });

            html += `<ul>${allOrders}</ul>`;

            $(resultsClass).html(html);
            loadingIndicator.hide();

        }).error(function (response) {
            console.warn(response);
            $(resultsClass).html('Oops, there was a problem. Please try again.');
            loadingIndicator.hide();
        });
    });

    let lceContainer = $('.listing-concierge-extension');
    lceContainer.on('click', '.listing-concierge-extension__button-dont-extend', (e) => {
        let parameter = 'lc_order_id_to_cancel';
        let buttonElement = $(e.target);
        let parentContainer = buttonElement.parent();
        let orderNumber = buttonElement.attr('data-order-id');
        let path = `/dashboard/boost/cancellceorder/cbhomes?${parameter}=${orderNumber}`;

        loadingIndicator.show();
        parentContainer.html('...');

        jQuery.getJSON(path).success(function (response) {
            parentContainer.html(response.message);
            loadingIndicator.hide();

        }).error(function (response) {
            console.warn(response);
            parentContainer.html('Oops, there was a problem.');
            loadingIndicator.hide();
        });
    });

    lceContainer.on('click', '.listing-concierge-extension__button-extend', (e) => {
        let parameter = 'lc_order_id_to_extend';
        let buttonElement = $(e.target);
        let parentContainer = buttonElement.parent();
        let orderNumber = buttonElement.attr('data-order-id');
        const selectDuration = parentContainer.find(".listing-concierge-extension__select-wrapper select");
        const durationDays = selectDuration.val();

        let path = `/dashboard/boost/extendlceorder/cbhomes?${parameter}=${orderNumber}&days=${durationDays}`;

        loadingIndicator.show();
        parentContainer.html('...');

        jQuery.getJSON(path).success(function (response) {
            parentContainer.html(response.message);
            loadingIndicator.hide();

        }).error(function (response) {
            console.warn(response);
            parentContainer.html('Oops, there was a problem.');
            loadingIndicator.hide();
        });
    });
});